import {Link} from "react-router";

import {Button} from "@/components/button/Button.tsx";
import {Sorting, SortingDirection} from "@/components/table/Table.types.ts";
import {GlobalAlertState} from "@/lib/types/alerting.ts";
import {AlertsTable} from "@/pages/alerting/components/list/AlertsTable.tsx";

interface DashboardAlertsProps {
  alerts: GlobalAlertState[];
  sortColumn: string;
  sortDirection: SortingDirection;
  onSortingChange?: (sorting: Sorting) => void;
  enableSorting?: boolean;
}

export const DashboardAlerts = ({alerts}: DashboardAlertsProps) => {
  return (
    <>
      <div className="mt-2 d-flex justify-content-between align-items-center">
        <div className="pulseTextH2Bold">Alerts</div>
        <Button as={Link} to={"/alerts"} variant="secondary">
          View All
        </Button>
      </div>
      <AlertsTable
        alerts={alerts}
        sortColumn={"-created_at"}
        sortDirection={SortingDirection.Asc}
        enableSorting={false}
        className={"mb-0 rounded-top rounded-bottom"}
        dataTestId="alerts-table"
      />
    </>
  );
};
